export const indexOfFirstProductImage = 0;
export const indexOfFirstProductImageForCart = 1;